<template>
  <div class="ylj-invite-record">
    <van-nav-bar title="邀请记录" left-arrow @click-left="$router.back()" />

    <div class="record-tip">
      <div class="tip-title">我的邀请</div>
      <div class="tip-desc">好友完成中国制造和中华云泊资产登记并审核通过后，即可获得3000元养老金奖励</div>
    </div>

    <div class="record-list">
      <div class="record-item" v-for="item in list" :key="item.id">
        <div class="record-left">
          <div class="record-mobile">{{ item.mobile }}</div>
          <div class="record-time">注册时间：{{ item.created_at }}</div>
        </div>
        <div class="record-right">
          <span :class="item.status==1?'active':'pending'">
            {{ item.status_text }}
          </span>
        </div>
      </div>

      <div v-if="!list.length&&!loading" class="empty">
        暂无邀请记录
      </div>

      <div v-if="loading" class="loading">
        加载中...
      </div>

      <div v-if="finished&&list.length" class="finished">
        没有更多了
      </div>
    </div>
  </div>
</template>

<script>
import request from "@utils/request";

export default{
  name:"YljInviteRecord",
  data(){
    return{
      list:[],
      page:1,
      loading:false,
      finished:false
    };
  },
  created(){
    this.getData();
  },
  methods:{
    getData(){
      if(this.loading||this.finished){
        return;
      }

      this.loading=true;

      request.get("/pension/invite/log",{page:this.page},{login:true}).then(res=>{
        if(res&&res.data&&res.data.data){
          const rows=res.data.data.list||[];
          this.list=this.list.concat(rows);

          if(rows.length<20){
            this.finished=true;
          }else{
            this.page++;
          }
        }
      }).catch(err=>{
        console.log(err);
        if(err.response&&err.response.data){
          this.$dialog.error(err.response.data.msg);
        }
      }).finally(()=>{
        this.loading=false;
      });
    }
  }
};
</script>

<style scoped>
.ylj-invite-record{
  min-height:100vh;
  background:#f6f7f9;
}
.record-tip{
  margin:12px;
  padding:18px;
  background:#fff;
  border-radius:12px;
}
.tip-title{
  font-size:18px;
  font-weight:bold;
  color:#222;
}
.tip-desc{
  margin-top:8px;
  font-size:13px;
  line-height:20px;
  color:#999;
}
.record-list{
  margin:12px;
  background:#fff;
  border-radius:12px;
  overflow:hidden;
}
.record-item{
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding:16px;
  border-bottom:1px solid #f1f1f1;
}
.record-item:last-child{
  border-bottom:0;
}
.record-mobile{
  font-size:16px;
  color:#333;
  font-weight:bold;
}
.record-time{
  margin-top:6px;
  font-size:12px;
  color:#999;
}
.record-right span{
  display:inline-block;
  padding:5px 10px;
  border-radius:20px;
  font-size:12px;
}
.record-right .active{
  color:#e53935;
  background:#fff1f1;
}
.record-right .pending{
  color:#999;
  background:#f5f5f5;
}
.empty{
  padding:50px 20px;
  text-align:center;
  color:#999;
  font-size:14px;
}
.loading,.finished{
  padding:18px;
  text-align:center;
  color:#999;
  font-size:13px;
}
</style>